module.exports = __webpack_public_path__ + "img/participant-list-mobile-fr.a4c21c8e.jpg";